import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavbarStatus, NavigationItem, NavigationService } from 'src/app/core/navigation.service';
import { UtilsService } from 'src/app/core/utils.service';
import { LOCAL_NAVBAR_STATUS_KEY } from 'src/app/shared/constants/operationals';
import { NavigationItemLabel } from 'src/app/shared/constants/translations';
import { BuyerDetailsGeneralComponent } from '../buyer-details-general/buyer-details-general.component';
import { BuyerDetailsOrderDataComponent } from '../buyer-details-order-data/buyer-details-order-data.component';
import { BuyerDetailsEventDataComponent } from '../buyer-details-event-data/buyer-details-event-data.component';

@Component({
  selector: 'app-buyer-details',
  templateUrl: './buyer-details.component.html',
  styleUrls: ['./buyer-details.component.scss'],
})
export class BuyerDetailsComponent {
  @ViewChild(BuyerDetailsGeneralComponent) general_component?: BuyerDetailsGeneralComponent;
  @ViewChild(BuyerDetailsEventDataComponent) event_component?: BuyerDetailsEventDataComponent;
  @ViewChild(BuyerDetailsOrderDataComponent) order_component?: BuyerDetailsOrderDataComponent;
  navbar_status: NavbarStatus;
  current_nav_item?: NavigationItem = this.navigation_service.navigation_set.nav_items.get(NavigationItemLabel.buyers);

  buyer_id: string | null;

  tabs = this.navigation_service.navigation_set.buyer_details_tabs;
  current_tab = this.tabs.get('article');

  constructor(
    private navigation_service: NavigationService,
    private utils_service: UtilsService,
    private route: ActivatedRoute,
  ) {
    this.navbar_status = (localStorage.getItem(LOCAL_NAVBAR_STATUS_KEY) as NavbarStatus) || NavbarStatus.closed;
    this.buyer_id = this.route.snapshot.paramMap.get('buyer_id');
  }

  ngOnInit(): void {
    this.current_tab = this.tabs.get('article');
  }

  onRefresh(): void {
    if (this.current_tab === this.tabs.get('article')) {
      this.general_component?.onRefresh();
    }

    if (this.current_tab === this.tabs.get('timeline')) {
      this.event_component?.onRefresh();
    }

    if (this.current_tab === this.tabs.get('receipt_long')) {
      this.order_component?.onRefresh();
    }
  }

  onTabChange(current_tab: string): void {
    this.current_tab = current_tab;
  }

  onNavbarStatusChange(navbar_status: NavbarStatus): void {
    this.navbar_status = navbar_status;
    localStorage.setItem(LOCAL_NAVBAR_STATUS_KEY, navbar_status);
  }

  getNavbarClass(): { [key: string]: boolean | undefined } {
    return this.utils_service.getNavbarClass(this.navbar_status);
  }

  getToolbarWidthClass(): string {
    if (this.navbar_status == NavbarStatus.open) {
      return 'sp-toolbar__open-width';
    }
    return 'sp-toolbar__closed-width';
  }
}
